import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ClassificacaoAction } from 'store/Classificacao/Classificacao.action';
import { ClassificacaoSelector } from 'store/Classificacao/Classificacao.selector';
import styled from 'styled-components';
import { CascaderField, CascaderProps } from "view/component/CascaderField/CascaderField";


export const ClassificacaoCascader: React.FunctionComponent<CascaderProps> = (props) => {
  const dispatch = useDispatch();

  const ocioso = useSelector(ClassificacaoSelector.lista.isOcioso);
  const carregando = useSelector(ClassificacaoSelector.lista.isCarregando);

  const classificacoes = useSelector(ClassificacaoSelector.lista.elementos);

  useEffect(() => {
    if (ocioso) {
      dispatch(ClassificacaoAction.iniciar());
    }
  }, [dispatch, ocioso]);

  return <CascaderField
    {...props}
    isLoading={carregando}
    floresta={classificacoes ?? []}
  /> 
}

export const ClassificacaoCascaderStyled = styled(ClassificacaoCascader)`
  width: 100%;
`;